import { Container } from '@mui/material'
import Title from '../../../../libs/rhf-mui/ui/Title'

type Props = {}

const Blank = (props: Props) => {
  return (
    <Container sx={{p:3}}>
    <Title color='error'>404 Not Found</Title>
    </Container>
  )
}

export default Blank